import { useLanguage } from '../../context/LanguageContext';

const FLAGS = [
  { code: 'en', flag: '🇬🇧', titleKey: 'nav.switchToEnglish' },
  { code: 'de', flag: '🇩🇪', titleKey: 'nav.switchToGerman' },
];

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className={`flex items-center space-x-1 bg-white/60 rounded-lg p-1 ${className}`}>
      {FLAGS.map(({ code, flag, titleKey }) => (
        <button
          key={code}
          type='button'
          onClick={() => setLanguage(code)}
          title={t(titleKey)}
          aria-label={t(titleKey)}
          aria-pressed={language === code}
          className={`text-xl leading-none px-1.5 py-1 rounded-md transition ${
            language === code
              ? 'bg-white shadow ring-1 ring-blue-400'
              : 'opacity-50 hover:opacity-100'
          }`}
        >
          {flag}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
